(() => {
  const titleSorts = ['title-ascending', 'title-descending'];
  const priceSorts = ['price-ascending', 'price-descending'];

  const normalizeLegacySort = () => {
    const collection = document.querySelector('[data-dx-collection-default-sort]');
    if (!collection) return;

    const url = new URL(window.location.href);
    const requestedSort = url.searchParams.get('sort_by');
    const priceSortAvailable = collection.dataset.dxCollectionPriceSortAvailable !== 'false';
    const unavailableSort = (value) => titleSorts.includes(value) || (!priceSortAvailable && priceSorts.includes(value));
    if (!unavailableSort(requestedSort)) return;

    const defaultSort = collection.dataset.dxCollectionDefaultSort;
    if (!defaultSort || unavailableSort(defaultSort)) return;

    // Reload from Shopify so ordering and pagination use the collection's real default.
    url.searchParams.set('sort_by', defaultSort);
    url.searchParams.delete('page');
    window.location.replace(`${url.pathname}${url.search}${url.hash}`);
  };

  const initialize = () => {
    normalizeLegacySort();

    // Dawn replaces this container's children when filters or browser history change.
    // Read the new server-side capability flag, including transitions across one page.
    const grid = document.getElementById('ProductGridContainer');
    if (grid && grid.querySelector('[data-dx-collection-default-sort]')) {
      new MutationObserver(normalizeLegacySort).observe(grid, { childList: true });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
